import script from "./FrameThree.vue?vue&type=script&setup=true&lang=js"
export * from "./FrameThree.vue?vue&type=script&setup=true&lang=js"

import "./FrameThree.vue?vue&type=style&index=0&id=1d20d00c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d20d00c"]])

export default __exports__